import type { Proposal } from "../types/proposal.types";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const generateProposalPDF = async (
  proposal: Proposal,
  returnBlob = false,
  selectedPages?: string[],
): Promise<Blob | void> => {
  const doc = new jsPDF({
    orientation: "p",
    unit: "mm",
    format: "a4",
    compress: true,
  });

  const allPages = [
    "cover",
    "main",
    "frequently",
    "services",
    "service",
    "whatsapp",
    "stream",
    "testimonial",
    "agreement",
    "team",
  ];

  const pages =
    selectedPages && selectedPages.length > 0 ? selectedPages : allPages;

  const stretchPages = ["cover", "frequently"];

  for (let i = 0; i < pages.length; i++) {
    const element = document.getElementById(`${pages[i]}-page-pdf`);
    if (!element) continue;

    await new Promise((r) => setTimeout(r, 50));

    const canvas = await html2canvas(element, {
      scale: Math.max(2, window.devicePixelRatio || 1),
      useCORS: true,
      allowTaint: true,
      backgroundColor: "#ffffff",
      logging: false,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/png");

    if (i > 0) doc.addPage();

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    const finalHeight = stretchPages.includes(pages[i])
      ? imgHeight < pageHeight
        ? pageHeight
        : imgHeight
      : imgHeight;

    doc.addImage(
      imgData,
      "PNG",
      0,
      0,
      imgWidth,
      finalHeight,
      undefined,
      "SLOW",
    );
  }

  if (returnBlob) {
    return doc.output("blob");
  }

  doc.save(
    `proposal-${
      proposal.eventTitle || proposal.deceasedName || "document"
    }.pdf`,
  );
};
